import { useTranslation } from 'react-i18next';
import { cancelQueue } from '../net/connection.js';
import { useSessionStore } from '../state/session-store.js';

/** Shown while the office is full: position in line, estimated wait and a way out. */
export function QueueScreen() {
  const { t } = useTranslation();
  const queue = useSessionStore((s) => s.queue);

  return (
    <main className="panel join" aria-live="polite">
      <h1>{t('queue.title')}</h1>
      <p className="tagline">{t('queue.full')}</p>
      {queue ? (
        <>
          <p className="queue-position">{t('queue.position', { position: queue.position })}</p>
          <p>{t('queue.eta', { minutes: Math.max(1, Math.ceil(queue.etaSeconds / 60)) })}</p>
          <p className="small">{t('queue.waiting', { count: queue.queued })}</p>
        </>
      ) : (
        <p>{t('connection.connecting')}</p>
      )}
      <p className="small">{t('queue.keepOpen')}</p>
      <div className="stack">
        <button type="button" className="secondary" onClick={cancelQueue}>
          {t('common.cancel')}
        </button>
      </div>
    </main>
  );
}
